<template>
    <a-modal
    :visible="visible"
    :title="$t('page_print_code')"
    @cancel="cancel()"
    width="800px"
    >
      <template slot="footer">
        <a-button @click="cancel">{{ $t('cancel') }}</a-button>
        <a-button type="primary" @click="print()">
          {{ $t('page_product_printing') }}
        </a-button>
        <a-button v-if="newList.length>1" type="primary" @click="printAll()">
          {{ $t('page_product_printing_all') }}
        </a-button>
      </template>
      <a-row>
        <a-col :span="11">
          <div class='code-background'>
              <div class="qr-code">
                <div class="qr">
                  <vue-qr :text="`${code}${codeType}`" :margin="0" colorDark="#000" colorLight="#fff" :logoScale="0.1" :size="200"></vue-qr>
                </div>
                  <div class="code-text">
                    <p class="code id">{{code}}</p>
                    <p class="code name">{{text}}</p>
                  </div>
              </div>
          </div>
        </a-col>
        <a-col :span="13" class="right-text">
          <div class="right-type">
            <span>{{$t('page_print_code_type')}}：</span>
           <a-select
           show-search
           optionFilterProp="children"
           :value="codeType" style="width: 300px" @change="handleChange">
               <template v-for="(t ,index) in qrdata">
                   <a-select-option :value="t.id" :key='index'>
                       {{t.name}}
                    </a-select-option>
               </template>
            </a-select>
          </div>
          <div class="right-code">
              <span>{{$t('page_product_code_preview')}}：</span>
              <div class="code-type-name" style="width: 300px">
                <ul class="code-list">
                  <li
                   v-for="(k, i) in newList"
                   :key="i"
                   :value="i"
                   :class="selectedKeys===i? 'active':''"
                   @click="handleClick"
                  >
                    {{k.code}}
                  </li>
                </ul>
                <!-- v-bind:class="{disabled:disabled, active:active}" -->
              </div>
          </div>
        </a-col>
      </a-row>
    </a-modal>
</template>

<script>
import Vue from 'vue'
import vueQr from 'vue-qr'
import { setLocalStorage } from "@/utils/storage";
const qrdata = [
        {
          id: 1,
          name: 'qr'
        },
        {
          id: 2,
          name: 'code128'
        },
        {
          id: 3,
          name: 'dataMatrix'
        },
      ]
      let patthrn=/.*[\u4e00-\u9fa5]+.*$/;
export default Vue.extend({
     name: 'CodeModel',
     components: {
        vueQr
    },
    data() {
    return {
        text: '',
        code: '',
        qrdata ,
        codeType: '',
        selectedKeys: 0,
        newList: []
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dataList: {
      type: Array,
      default: []
    }
  },
  watch: {
    visible: {
      handler(val) {
        if(val) {
          if(this.dataList.length) {
            this.newList = this.dataList
            this.code = this.newList[0].code
            if(this.newList[0].hasOwnProperty('name')&&this.newList[0].name){
              this.text = this.newList[0].name
            }else {
              this.text = this.newList[0].code
            }
            this.codeType = this.qrdata[0].name
          }
        }
        else{
          this.newList = []
        }
      }
    }
  },

  methods: {
    getInitialization() {
      this.code = ''
      this.text = ''
      this.codeType = ''
      this.selectedKeys = 0
    },
    print() {
      window.localStorage.removeItem('printQrArr')
      const param = {
        code: this.code,
        name: this.text,
        codeType: this.codeType
      }
      let routeUrl = this.$router.resolve({
        path: '/printCodeRules'
      })
      window.localStorage.setItem("printQr",JSON.stringify(param))
      window.open(routeUrl.href, '_blank')
      this.cancel()
    },
    printAll() {
     window.localStorage.removeItem('printQr')
     let arr = [...this.newList]
     arr.map(res => {
       res['codeType'] = this.codeType
     })
    let routeUrl = this.$router.resolve({
        path: '/printCodeRules'
      })
     window.localStorage.setItem("printQrArr",JSON.stringify(arr))
     window.open(routeUrl.href, '_blank')
     this.cancel()
    },
    cancel(){
      this.getInitialization()
      this.$emit('cancel')
    },
    handleChange(val){
      //如果code的是中文就不让选择编码为'code128'直接提示
      qrdata.map(item => {
        if(patthrn.test(this.code)) {
          if(val === item.id && item.name === 'code128') {
             this.$message.error(this.$t("page_code_128_cannot_be_selected_because_Chinese_exists_in_the_code"))
          }
          if(val === item.id && item.name !== 'code128'){
             this.codeType = item.name
          }
        }else {
          if(val === item.id) {
            this.codeType = item.name
          }
        }
      })
    },
    handleClick(val){
      const index = val.target.value
      const code = val.target.innerText
      if(this.codeType === 'code128') {
         if(patthrn.test(code)){
           this.$message.error(this.$t('page_Code128_code_can_not_exist_in_Chinese_please_change_the_coding_method'))
         } else {
           this.selectedKeys = index
           this.code = code
           this.newList.map(item => {
             if(code === item.code) {
               if(item.hasOwnProperty('name')&&item.name){
                 this.text = item.name
               }else {
                 this.text = item.code
               }
             }
           })
         }
      }else {
        this.selectedKeys = index
        this.code = code
        this.newList.map(item => {
          if(code === item.code) {
            if(item.hasOwnProperty('name')&&item.name){
              this.text = item.name
            }else {
              this.text = item.code
            }
          }
        })
      }
    }
  }
})
</script>
<style lang="less">
.code-background {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color:rgba(223, 223, 231, 0.25);
    width: 100%;
    height: 500px;
    margin-right: 20px;
    .code-text {
        font-size: 20px;
        text-align: center;
        .code {
            width: 250px;
            word-wrap: break-word;
            word-break: normal;
        }
        .id {
            margin-top: 20px;
        }
        .name {
            margin-top: -18px;
        }
    }
}
.qr {
  width: 100%;
  display: flex;
  justify-content: center;
}
.right-text{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    .right-code{
      margin-top: 20px;
      display: flex;
      .code-type-name{
      border: 1px solid rgb(223, 213, 213);
      height: 450px;
      overflow-y: auto;
      overflow-x: hidden;
        .list{
          padding-left: 10px;
          padding-top: 10px;
        }
      }
    }
}
.code-list {
  li {
    line-height: 1.5;
    margin: 2px 5px;
    padding: 5px 10px;
    padding-left: 6px;
    cursor:default
  }
}
.active {
  background-color: rgb(168, 214, 252);
  color:#666;
}
</style>
